var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-legal-dialog',{attrs:{"url":"/privacy-policy","title":_vm.__('legalPrivacyPolicy')}})
}
var staticRenderFns = []

export { render, staticRenderFns }